<template>
  <div class="IOArchive">
    <box class="" :title="this.$t('search')">
      <div class="px-3 pt-2">
        <v-row class="mt-2">
          <v-col cols="12" sm="6">
            <v-row>
              <v-col cols="auto" class="max-width-text-title px-1 d-flex">
                <label class="my-auto">{{ $t("fromDate") }} : </label>
              </v-col>
              <v-col>
                <dialog-date-picker
                  :label="$t('fromDate') + ':'"
                  :initDate="initBeginDate"
                  @dateResult="bDate"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="6">
            <v-row class="mt-2 mt-sm-0">
              <v-col cols="auto" class="max-width-text-title px-1 d-flex">
                <label class="my-auto">{{ $t("toDate") }} : </label>
              </v-col>
              <v-col>
                <dialog-date-picker
                  :label="$t('toDate') + ':'"
                  :initDate="initEndDate"
                  @dateResult="eDate"
                />
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" sm="6">
            <v-row class="mt-2">
              <v-col cols="auto" class="max-width-text-title px-1 d-flex">
                <label class="my-auto">{{ $t("requestType") }} : </label>
              </v-col>
              <v-col>
                <v-select
                  hide-details
                  v-model="ioRequestType"
                  :items="ioRequestTypes"
                  :label="$t('requestType')"
                  item-text="Name"
                  item-value="Code"
                  return-object
                  dense
                  solo
                  v-on:change="changeIOType"
                  class="my-auto py-0"
                ></v-select>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-card-actions class="px-0 pt-4">
          <v-spacer></v-spacer>

          <v-btn
            class="px-5"
            color="primary"
            :loading="isLoading"
            @click="search"
            >{{ $t("search") }}</v-btn
          >
        </v-card-actions>
      </div>
    </box>

    <box class="mt-2" :title="$t('ioList')">
      <div class="ioList">
        <div v-if="list.length > 0">
          
          <v-alert
            class="ma-2"
            text
            dense
            color="teal"
            icon="mdi-comment-alert-outline"
            border="left"
          >
            توجه: سطر های سبز رنگ ورود و خروج های ثبت شده از طریق دستگاه ساعت می
            باشند.
          </v-alert>

          <PersonIOListWeb
           :pagination="true"
            @onClickIO="onClickIO"
            :list="list"
            class="hidden-sm-and-down"
          />
          <PersonIOListMob
            @onClickIO="onClickIO"
            :list="list"
            class="hidden-md-and-up"
          />
        </div>
        <div v-else>
          <EmptyList />
        </div>
      </div>
    </box>

    <IOArchiveDetails class="mt-2" ref="IOArchiveDetails" @refresh="search" />
  </div>
</template>

<script>
import IOArchiveDetails from "../../components/request/IOArchiveDetails.vue";
import PersonIOListMob from "../../components/request/PersonIOList/PersonIOListMob.vue";
import PersonIOListWeb from "../../components/request/PersonIOList/PersonIOListWeb.vue";
import DialogDatePicker from "../../components/widget/DialogDatePicker.vue";
import EosToastType from "../../model/EosToastType";
import type from "../../model/IORequestType";
//import TextUtils from "../../utils/TextUtils";

export default {
  components: {
    DialogDatePicker,
    PersonIOListWeb,
    PersonIOListMob,
    IOArchiveDetails,
  },
  data() {
    return {
      ioRequestTypes: [],
      ioRequestType: "",
      isLoading: false,
      initBeginDate: null,
      beginDate: "",
      initEndDate: null,
      endDate: "",
      list: [],
    };
  },
  mounted() {
    var moment = require("jalali-moment");
    var year = moment().locale("fa").format("YYYY");
    this.initBeginDate = year + "/01/01";

    this.initEndDate = moment().locale("fa").endOf("year").format("YYYY/MM/DD");

    this.ioRequestTypes = type.IORequestTypeArray();
    if (this.ioRequestTypes.length > 0) {
      this.ioRequestType = this.ioRequestTypes[0];
    }
  },
  methods: {
    bDate(date) {
      this.beginDate = date;
      this.search();
    },
    eDate(date) {
      this.endDate = date;
      this.search();
    },
    changeIOType() {
      this.search();
    },
    search() {
      if (!this.beginDate || !this.endDate) {
        return;
      }
      this.hideDetails();

      const params = new URLSearchParams();
      params.append("beginDate", this.beginDate);
      params.append("endDate", this.endDate);
      params.append("searchKind", this.ioRequestType.Code);

      this.$store.dispatch("GetIoListForArchive", { params }).then((result) => {
        //console.log(result);
        if (result.type === "success") {
          this.list = result.data;
        } else {
          this.list = [];
          this.$EosToast.show({
            type: EosToastType.error,
            msg: result.error || "error",
          });
        }
      });
    },
    onClickIO(item) {
      ////console.log(item);
      this.hideDetails();
      this.$refs.IOArchiveDetails.show(item);
    },
    hideDetails() {
      this.$refs.IOArchiveDetails.hide();
    },
  },
};
</script>

<style scoped>
.max-width-text-title {
  width: 100px;
}
</style>